module.exports = __webpack_public_path__ + "6d2db1e06df4de93bb438d9195ae2329.svg";